var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlotanteWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flotante_whatsapp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 54,
    viewBox: "0 0 94 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_whatsapp_flotante",
    transform: "translate(11057.117 1045.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_7",
    "data-name": "Elipse 7",
    transform: "translate(-11017.117 -1045.117)",
    fill: "#00a884",
    stroke: "#1c1c1c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "whatsapp",
    transform: "translate(-11006.117 -1034.117)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_21",
    "data-name": "Rect\\xE1ngulo 21",
    width: 32,
    height: 32,
    fill: "#1c1c1c",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M0,27.862v0l1.96-7.151a13.827,13.827,0,1,1,5.368,5.233L0,27.862Zm8.088-4.17a11.478,11.478,0,1,0-3.881-3.778l.274.434L3.32,24.581l4.348-1.139ZM16.2,20.244a20.162,20.162,0,0,1-1.969-.727,15.394,15.394,0,0,1-5.9-5.208A6.715,6.715,0,0,1,6.916,10.74,3.871,3.871,0,0,1,8.125,7.861a1.268,1.268,0,0,1,.921-.432c.231,0,.461,0,.662.012h.077c.2,0,.452,0,.7.591.289.69.978,2.388,1.066,2.56a.637.637,0,0,1,.029.605,2.4,2.4,0,0,1-.346.575c-.172.2-.362.449-.519.6-.172.172-.352.359-.151.7a10.4,10.4,0,0,0,1.922,2.39,9.411,9.411,0,0,0,2.779,1.712c.345.172.546.143.747-.086s.865-1.008,1.095-1.353.461-.288.777-.173,2.015.95,2.36,1.123.576.258.662.4a2.886,2.886,0,0,1-.2,1.641,3.56,3.56,0,0,1-2.331,1.64,5.692,5.692,0,0,1-.84.066A4.4,4.4,0,0,1,16.2,20.244Z",
    transform: "translate(2 2)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_99",
    "data-name": "Grupo 99",
    transform: "translate(11059 1049)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_59",
    "data-name": "Rect\\xE1ngulo 59",
    d: "M4,0H46a0,0,0,0,1,0,0V20a0,0,0,0,1,0,0H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(-11059 -1032)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_Hola_",
    "data-name": "\\xA1Hola!",
    transform: "translate(-11037.182 -1018)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Quicksand-Regular, Quicksand"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.18,
    y: 0
  }, "\xA1Hola!")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlotanteWhatsapp);
export default __webpack_public_path__ + "static/media/flotante_whatsapp.9c40db50251f04197cbc58f742dbbe97.svg";
export { ForwardRef as ReactComponent };